<template>
  <router-view />
</template>
<script setup>
  import { initThemeScheme } from '@/utils/js/themeScheme';
  initThemeScheme();
</script>